import { mLabel, fmtN, num, sum, r2 } from "./BpKit";

const Cell = ({ value, onChange, readOnly, tid }) => (readOnly
  ? <span data-testid={tid} className="num text-xs text-slate-500">{value === "" || value == null ? "·" : fmtN(value)}</span>
  : <input data-testid={tid} type="number" min="0" step="any" inputMode="decimal" value={value ?? ""} onChange={(e) => onChange(e.target.value)}
      className="num w-[72px] h-8 px-1.5 text-right text-[13px] bg-white border border-slate-200 rounded-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary/30" />);

const Row = ({ r, months, onCell, readOnly, tid, lead }) => (
  <tr className={r.ref ? "bg-slate-50/70" : ""} data-testid={`${tid}-row-${r.key}`}>
    <td className="min-w-[190px]">
      <div className={`text-[13px] ${r.ref ? "text-slate-500 italic" : "font-medium text-slate-800"}`}>{r.label}</div>
      {r.sub && <div className="text-[11px] text-slate-500">{r.sub}</div>}
    </td>
    {lead && lead(r)}
    {months.map((m) => (
      <td key={m} className="text-right">
        <Cell value={r.values?.[m]} readOnly={readOnly || r.ref} onChange={(v) => onCell(r.key, m, v)} tid={`${tid}-${r.key}-${m}`} />
      </td>
    ))}
    <td className="text-right num text-[13px] font-semibold" data-testid={`${tid}-${r.key}-total`}>{fmtN(r2(sum(r.values)))}</td>
    {r.tail !== undefined && <td className="text-right">{r.tail}</td>}
  </tr>
);

export const MonthGrid = ({ tid, months, rows, onCell, readOnly, totalLabel, leadHead, leadCols = 0, lead, tailHead }) => {
  const editable = rows.filter((r) => !r.ref);
  return (
    <div className="overflow-x-auto border border-slate-200 rounded-sm" data-testid={tid}>
      <table className="ax-table ax-freeze w-full">
        <thead>
          <tr>
            <th>Row</th>
            {leadHead}
            {months.map((m) => <th key={m} className="text-right">{mLabel(m)}</th>)}
            <th className="text-right">FY total</th>
            {tailHead && <th />}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => <Row key={r.key} r={r} months={months} onCell={onCell} readOnly={readOnly} tid={tid} lead={lead} />)}
          {totalLabel && editable.length > 1 && (
            <tr className="bg-slate-100/80 font-semibold" data-testid={`${tid}-sum-row`}>
              <td className="text-[13px]">{totalLabel}</td>
              {leadCols > 0 && <td colSpan={leadCols} />}
              {months.map((m) => <td key={m} className="text-right num text-[13px]">{fmtN(r2(editable.reduce((a, r) => a + num(r.values?.[m]), 0)))}</td>)}
              <td className="text-right num text-[13px]">{fmtN(r2(editable.reduce((a, r) => a + sum(r.values), 0)))}</td>
              {tailHead && <td />}
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
